<script lang="ts">
</script>

<section id="newsletter" class="bg-white py-20 lg:py-[120px] overflow-hidden relative z-10">
    <div class="container">
        <div class="flex flex-wrap lg:justify-between -mx-4">
            <div class="w-full lg:w-1/2 xl:w-6/12 px-4">
                <div class="max-w-[570px] mb-12 lg:mb-0">
               <span class="block mb-4 text-base text-primary font-semibold">
               Newsletter
               </span>
                    <h2
                            class="
                  text-dark
                  mb-6
                  font-bold
                  text-[32px]
                  sm:text-[40px]
                  lg:text-[36px]
                  xl:text-[40px]
                  "
                    >
                        Get in touch.
                    </h2>
                    <p class="text-base text-body-color leading-relaxed mb-9">
                        We'll let you know once we're ready to help your business.
                    </p>
                    <p class="text-base text-body-color leading-relaxed mb-9">
                        Have questions, requests, or suggestions? <br/>
                        Contact us here:
                    </p>
                    <div class="flex mb-8 max-w-[370px] w-full">
                        <div
                                class="
                     max-w-[60px]
                     sm:max-w-[70px]
                     w-full
                     h-[60px]
                     sm:h-[70px]
                     flex
                     items-center
                     justify-center
                     mr-6
                     overflow-hidden
                     bg-primary bg-opacity-5
                     text-primary
                     rounded
                     "
                        >
                            <svg
                                    width="28"
                                    height="19"
                                    viewBox="0 0 28 19"
                                    class="fill-current"
                            >
                                <path
                                        d="M25.3636 0H2.63636C1.18182 0 0 1.16785 0 2.6052V16.3948C0 17.8322 1.18182 19 2.63636 19H25.3636C26.8182 19 28 17.8322 28 16.3948V2.6052C28 1.16785 26.8182 0 25.3636 0ZM25.3636 1.5721C25.5909 1.5721 25.7727 1.61702 25.9545 1.75177L14.6364 8.53428C14.2273 8.75886 13.7727 8.75886 13.3636 8.53428L2.04545 1.75177C2.22727 1.66194 2.40909 1.5721 2.63636 1.5721H25.3636ZM25.3636 17.383H2.63636C2.09091 17.383 1.59091 16.9338 1.59091 16.3499V3.32388L12.5 9.8818C12.9545 10.1513 13.4545 10.2861 13.9545 10.2861C14.4545 10.2861 14.9545 10.1513 15.4091 9.8818L26.3182 3.32388V16.3499C26.4091 16.9338 25.9091 17.383 25.3636 17.383Z"
                                />
                            </svg>
                        </div>
                        <div class="w-full">
                            <h4 class="font-bold text-dark text-xl mb-1">
                                Email Address
                            </h4>
                            <p class="text-base text-body-color"><a href="mailto:info@nolines.online">info@nolines.online</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/2 xl:w-5/12 px-4">
                <div class="bg-white relative rounded-lg p-8 sm:p-12 shadow-lg">
                    <form action="https://buttondown.email/api/emails/embed-subscribe/NoLines"
                          method="post"
                          target="popupwindow"
                          onsubmit="window.open('https://buttondown.email/NoLines', 'popupwindow')">
                        <div class="mb-6">
                            <input
                                    type="email"
                                    name="email"
                                    required
                                    placeholder="Your Email"
                                    class="
                                        w-full
                                        rounded
                                        py-3
                                        px-[14px]
                                        text-body-color text-base
                                        border border-[f0f0f0]
                                        outline-none
                                        focus-visible:shadow-none
                                        focus:border-primary
                                    "
                            />
                        </div>
                        <div>
                            <input
                                    value="Subscribe to newsletter"
                                    type="submit"
                                    class="
                        w-full
                        text-white
                        bg-primary
                        rounded
                        border border-primary
                        p-3
                        transition
                        hover:bg-opacity-90
                        "
                            />
                        </div>
                    </form>
                    <div>
                  <span class="absolute -top-10 -right-9 z-[-1]">
                     <svg
                             width="100"
                             height="100"
                             viewBox="0 0 100 100"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M0 100C0 44.7715 0 0 0 0C55.2285 0 100 44.7715 100 100C100 100 100 100 0 100Z"
                                fill="#3056D3"
                        />
                     </svg>
                  </span>
                        <span class="absolute -right-10 top-[90px] z-[-1]">
                     <svg
                             width="34"
                             height="134"
                             viewBox="0 0 34 134"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                     >
                        <circle
                                cx="31.9993"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 31.9993 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 31.9993 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 31.9993 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 31.9993 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 31.9993 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 31.9993 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 31.9993 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 31.9993 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 31.9993 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 31.9993 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 17.3333 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 17.3333 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 17.3333 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 17.3333 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 17.3333 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 17.3333 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 17.3333 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 17.3333 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 17.3333 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 17.3333 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 2.66536 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 2.66536 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 2.66536 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 2.66536 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 2.66536 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 2.66536 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 2.66536 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 2.66536 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 2.66536 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 2.66536 1.66665)"
                                fill="#13C296"
                        />
                     </svg>
                  </span>
                        <span class="absolute -left-7 -bottom-7 z-[-1]">
                     <svg
                             width="107"
                             height="134"
                             viewBox="0 0 107 134"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg"
                     >
                        <circle
                                cx="104.999"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 104.999 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 104.999 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 104.999 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 104.999 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 104.999 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 104.999 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 104.999 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 104.999 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 104.999 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="104.999"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 104.999 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 90.3333 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 90.3333 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 90.3333 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 90.3333 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 90.3333 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 90.3333 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 90.3333 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 90.3333 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 90.3333 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="90.3333"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 90.3333 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 75.6654 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 31.9993 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 75.6654 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 31.9993 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 75.6654 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 31.9993 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 75.6654 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 31.9993 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 75.6654 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 31.9993 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 75.6654 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 31.9993 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 75.6654 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 31.9993 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 75.6654 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 31.9993 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 75.6654 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 31.9993 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="75.6654"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 75.6654 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="31.9993"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 31.9993 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 60.9993 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 17.3333 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 60.9993 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 17.3333 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 60.9993 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 17.3333 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 60.9993 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 17.3333 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 60.9993 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 17.3333 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 60.9993 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 17.3333 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 60.9993 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 17.3333 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 60.9993 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 17.3333 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 60.9993 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 17.3333 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="60.9993"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 60.9993 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="17.3333"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 17.3333 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 46.3333 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="132"
                                r="1.66667"
                                transform="rotate(180 2.66536 132)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 46.3333 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="117.333"
                                r="1.66667"
                                transform="rotate(180 2.66536 117.333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 46.3333 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="102.667"
                                r="1.66667"
                                transform="rotate(180 2.66536 102.667)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 46.3333 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="88"
                                r="1.66667"
                                transform="rotate(180 2.66536 88)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 46.3333 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="73.3333"
                                r="1.66667"
                                transform="rotate(180 2.66536 73.3333)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 46.3333 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="45"
                                r="1.66667"
                                transform="rotate(180 2.66536 45)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 46.3333 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="16"
                                r="1.66667"
                                transform="rotate(180 2.66536 16)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 46.3333 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="59"
                                r="1.66667"
                                transform="rotate(180 2.66536 59)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 46.3333 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="30.6666"
                                r="1.66667"
                                transform="rotate(180 2.66536 30.6666)"
                                fill="#13C296"
                        />
                        <circle
                                cx="46.3333"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 46.3333 1.66665)"
                                fill="#13C296"
                        />
                        <circle
                                cx="2.66536"
                                cy="1.66665"
                                r="1.66667"
                                transform="rotate(180 2.66536 1.66665)"
                                fill="#13C296"
                        />
                     </svg>
                  </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>